const pavilions = {
    'Trgovina': {
                id: 0,
                slug: 'Trgovina',
                background: "/images/pavilion1.jpg",
                stands: [
                    {
                        id: 0,
                        slug: 'MojPosao',
                        background: '/images/stand5.jpg',
                        logo: '/images/logo.png',
                        modules: 5,
                        elements: [
							{
								id: 14,
								type: 'decoration',
								subtype: 'desk',
								image: '/images/magenta.png',
								positionX: 0,
								positionY: 85
							},
                            {
                                id: 0,
                                type: 'decoration',
                                subtype: 'person',
                                image: '/images/stands/person2.png',
                                positionX: 100,
                                positionY: 30
                            },
                            {
                                id: 1,
                                type: 'decoration',
                                subtype: 'desk',
                                image: '/images/stands/desk1.png',
                                positionX: 100,
                                positionY: 20
                            },
							{
								id: 11,
								type: 'decoration',
								subtype: 'desk',
								image: '/images/table-1.png',
								positionX: 1400,
								positionY: 20
							},
							{
								id: 12,
								type: 'decoration',
								subtype: 'desk',
								image: '/images/plant-13.png',
								positionX: 2100,
								positionY: 50
							},
                            {
                                id: 2,
                                type: 'gallery',
                                subtype: 'gallery',
                                image: '/images/stands/gallery0.png',
                                gallery: [{
                                    id: 0, item: '/images/pavilions/MojPosao.png'
                                },
                                    {
                                        id: 1, item: '/images/hamburger.svg'
                                    }],
                                positionX: 50,
                                positionY: 15
                            },
                            {
                                id: 3,
                                type: 'offers',
                                subtype: 'offers',
                                image: '/images/stands/gallery0.png',
                                offers: [
                                    {
                                        id: 0, title: 'Prodavač', location: 'Zagreb', deadline: '25.10.2018.'
                                    },
                                    {
                                        id: 1, title: 'Instalacije klime', location: 'Pula', deadline: '29.10.2018.'
                                    },
                                    {
                                        id: 2, title: 'Kirurg', location: 'Zadar', deadline: '11.10.2018.'
                                    },
                                    {
                                        id: 3, title: 'Konobar', location: 'Slavonski brod', deadline: '29.10.2018.'
                                    },
                                    {
                                        id: 4, title: 'Psiholog', location: 'Toronto', deadline: '29.12.2018.'
                                    }
                                ],
                                positionX: 1310,
                                positionY: 415
                            }
                        ]},
                    {
                        id: 1,
                        slug: 'MojaBanka',
                        background: '/images/stand3.jpg',
                        logo: '/images/pavilions/MojPosao.png',
                        modules: 3,
                        elements: [
                            {
                                id: 0,
                                type: 'decoration',
                                subtype: 'person',
                                image: '/images/stands/person1.png',
                                positionX: 100,
                                positionY: 15
                            }
                        ]},
                    {
                        id: 2,
                        slug: 'MojaTrgovina',
                        background: '/images/stand7.jpg',
                        logo: '/images/pavilions/MojPosao.png',
                        modules: 7,
                        elements: [
                            {
                                id: 0,
                                type: 'decoration',
                                subtype: 'person',
                                image: '/images/stands/person3.png',
                                positionX: 150,
                                positionY: 15
                            }
                        ]}
                ]},
    'Financije': {
                id: 1,
                slug: 'Financije',
                background: "/images/pavilion1.jpg",
                stands: [
                    {
                        id: 2,
                        slug: 'MojaTrgovina',
                        background: '/images/stand3.jpg',
                        logo: '/images/pavilions/MojPosao.png',
                        modules: 3,
                        elements: [
                            {
                                id: 0,
                                type: 'decoration',
                                subtype: 'person',
                                image: '/images/stands/person2.png',
                                positionX: 150,
                                positionY: 15
                            }
                        ]},
                    {
                        id: 1,
                        slug: 'MojPosao',
                        background: '/images/stand5.jpg',
                        logo: '/images/logo.png',
                        modules: 5,
                        elements: [
                            {
                                id: 0,
                                type: 'decoration',
                                subtype: 'person',
                                image: '/images/stands/person3.png',
                                positionX: 20,
                                positionY: 15
                            },
                            {
                                id: 1,
                                type: 'decoration',
                                subtype: 'desk',
                                image: '/images/stands/desk3.png',
                                positionX: 20,
                                positionY: 15
                            },
                            {
                                id: 2,
                                type: 'gallery',
                                subtype: 'gallery',
                                image: '/images/stands/gallery0.png',
                                gallery: [{
                                    id: 0, item: '/images/pavilions/MojPosao.png'
                                },
                                    {
                                        id: 1, item: '/images/hamburger.svg'
                                    }],
                                positionX: 70,
                                positionY: 15
                            },
                            {
                                id: 3,
                                type: 'offers',
                                subtype: 'offers',
                                image: '/images/stands/gallery0.png',
                                offers: [
                                    {
                                        id: 0, title: 'Prodavač', location: 'Zagreb', deadline: '25.10.2018.'
                                    },
                                    {
                                        id: 1, title: 'Instalacije klime', location: 'Pula', deadline: '29.10.2018.'
                                    },
                                    {
                                        id: 2, title: 'Kirurg', location: 'Zadar', deadline: '11.10.2018.'
                                    },
                                    {
                                        id: 3, title: 'Konobar', location: 'Slavonski brod', deadline: '29.10.2018.'
                                    },
                                    {
                                        id: 4, title: 'Psiholog', location: 'Toronto', deadline: '29.12.2018.'
                                    }
                                ],
                                positionX: 50,
                                positionY: 15
                            }
                        ]},
                    {
                        id: 3,
                        slug: 'MojaBanka',
                        background: '/images/stand7.jpg',
                        logo: '/images/pavilions/MojPosao.png',
                        modules: 7,
                        elements: [
                            {
                                id: 0,
                                type: 'decoration',
                                subtype: 'person',
                                image: '/images/stands/person3.png',
                                positionX: 20,
                                positionY: 15
                            }
                        ]}
                ]}
};

export { pavilions };


// WEBPACK FOOTER //
// ./src/modules/model/data.js